import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { compose } from 'redux';
import { withWidget } from '../context';
import {
  changeCurrentTemplateId,
  deleteTemplateRequest,
  REDUCER_NAME,
} from '../reducer';
import CurrentTemplate from './CurrentTemplate';
import ListTemplate, { TABS } from './ListTemplate';

class TabContent extends PureComponent {
  state = {
    activeIndex: 0,
  };

  onItemClick = index => {
    this.setState({
      activeIndex: index,
    });
  };

  onLoadTemplate = (config, id) => {
    const {
      widget,
      changePopUpStatus,
      changeCurrentTemplateId,
      theme,
    } = this.props;
    if (!config) {
      return;
    }
    const state = JSON.parse(config);
    const symbol = widget.chart().symbol();
    widget.load(state);
    setTimeout(() => {
      widget.changeTheme(theme);
      widget.chart().setSymbol(symbol);
    });
    changePopUpStatus(false);
    changeCurrentTemplateId(id);
  };

  onDeleteTemplate = id => {
    const { deleteTemplateRequest } = this.props;
    deleteTemplateRequest({ layoutId: id });
  };

  getItems = () => {
    const { items, search, currentTab } = this.props;
    const condition = item =>
      currentTab === TABS.myTemplate ? item.isCustom : !item.isCustom;

    return items.filter(
      item =>
        condition(item) &&
        item.name.toLowerCase().includes(search.toLowerCase()),
    );
  };

  render() {
    const { activeIndex } = this.state;
    const listTemplate = this.getItems();
    if (!listTemplate.length) {
      return (
        <div className="no-template">
          <Translate value="charting.noTemplate" />
        </div>
      );
    }

    return (
      <div className="d-flex">
        <ListTemplate onItemClick={this.onItemClick} items={listTemplate} />
        {listTemplate[activeIndex] && (
          <CurrentTemplate
            onDeleteTemplate={this.onDeleteTemplate}
            onLoadTemplate={this.onLoadTemplate}
            item={listTemplate[activeIndex]}
          />
        )}
      </div>
    );
  }
}

TabContent.propTypes = {
  items: PropTypes.array,
  widget: PropTypes.object.isRequired,
  changePopUpStatus: PropTypes.func.isRequired,
  changeCurrentTemplateId: PropTypes.func.isRequired,
  deleteTemplateRequest: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
};

TabContent.defaultProps = {
  items: [],
};

const mapStateToProps = state => ({
  items: state[REDUCER_NAME].templates,
  theme: state.theme,
});

const mapDispatchToProps = {
  deleteTemplateRequest,
  changeCurrentTemplateId,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withWidget,
)(TabContent);
